export default {
    pluginName: 'drug',
    backendDataType: 'DRUG',
    rowIdKey: 'DRUG_ID',
    edit: 'data_edit',
    count: 'drug_count',
    totalCount: 'total_drug_count',
    fieldI18nKey: 'commonDrug',
    maxPerFolder: 'max_drug_per_folder',
    maxOp: 'max_op_drug',
    staticFields: [],
    dataId: 'DRUG_ID',
};
